import { API_INSTANCE, fullBuildURL } from 'src/features/utils';
import {
  EventsFiltersResponse,
  FetchValuesPayload,
} from 'src/redesign/features/EventsFilters/types';

export const fetchEventAttendeesFilterValuesApi = async ({
  eventId,
  criteria,
}: FetchValuesPayload) => {
  const queryParams = new URLSearchParams(criteria).toString();
  return API_INSTANCE.get<EventsFiltersResponse>(
    fullBuildURL(`/api/v1/dashboard/events/${eventId}/filter-values`, queryParams)
  );
};
